(function ($) {
  $(function () {
    var accordion = $(".js-accordion-toggle");
    var accordionHeader = $(".js-accordion-header");

    accordionHeader.on("click", function () {
      var currentAccordion = $(this).parent();

      currentAccordion.toggleClass("active");
      
      accordion.not(currentAccordion).removeClass("active");
    });
  });
})(jQuery);
